import { exchangeMetafieldDisplayConfigSchema } from "@redotech/redo-return-core-common/exchange-metafield-display";
import * as z from "zod";

export const setShopifyMetafieldsToDisplayOnExchangeItems = {
  name: "setShopifyMetafieldsToDisplayOnExchangeItems" as const,
  input: z.object({
    shopifyMetafieldsToDisplayOnExchangeItems: z.array(
      exchangeMetafieldDisplayConfigSchema,
    ),
  }),
  output: z.null(),
};
